export default __webpack_public_path__ + "static/media/Ds.eedd6266.pdf";